function getClippedText(text?: string, maxLength: number = 40) {
  if (!text) return '-';

  if (text.length > maxLength) return `${text.substring(0, maxLength)}...`;

  return text;
}

export default getClippedText;
